import {
  DETAIL_GET_COMMENT_LIST_SUCCESS,
  DETAIL_GET_GRADE_SUCCESS,
  DETAIL_ADD_COMMENT_SUCCESS,
  DETAIL_ADD_ZAN_SUCCESS,
  USER_SCORE_FORSTORE_SUCCESS,
  COMMENT_GET_APP_LIST_SUCCESS,
  COMMENT_GET_ZT_LIST_SUCCESS,
  COMMENT_GET_INFO_SUCCESS,
  COMMENT_GET_UP_PARAMS_SUCCESS,
  COMMENT_ADD_CONENT_SUCCESS,
} from '../constants/comment';

const initState = {
  commentList: {},
  grade: {},
  addComment: {
    inLoadding: false,
  },
  addZan: {},
  userScoreForStore: {},
  commentInfo: {},
  addCommentCon: {
    Loading: false,
  },
  appList: null,
  ztList: null,
  uploadParams: {},
};

const comment = (state = initState, action = {}) => {
  switch (action.type) {
    case DETAIL_GET_COMMENT_LIST_SUCCESS:
      return { ...state, commentList: action.payload };
    case DETAIL_GET_GRADE_SUCCESS:
      return { ...state, grade: action.payload };
    case DETAIL_ADD_COMMENT_SUCCESS:
      return { ...state, addComment: action.payload };
    case DETAIL_ADD_ZAN_SUCCESS:
      return { ...state, addZan: action.payload };
    case USER_SCORE_FORSTORE_SUCCESS:
      return { ...state, userScoreForStore: action.payload };
    case COMMENT_GET_APP_LIST_SUCCESS:
      return { ...state, appList: action.payload };
    case COMMENT_GET_ZT_LIST_SUCCESS:
      return { ...state, ztList: action.payload.zts };
    case COMMENT_GET_INFO_SUCCESS:
      return { ...state, commentInfo: action.payload };
    case COMMENT_GET_UP_PARAMS_SUCCESS:
      return { ...state, uploadParams: action.payload };
    case COMMENT_ADD_CONENT_SUCCESS:
      return { ...state, addCommentCon: action.payload };
    default:
      return state;
  }
};

export default comment;
